export default "__VITE_ASSET__DbsoWMsh__"